Ext.define('SA.view.color.RecentColors', {
    alias: 'widget.recent-colors',
    extend: 'Ext.view.View',

    cls: 'sa-color-window-recent x-unselectable',
    itemSelector: '.sa-color-window-item',
    overItemCls: 'sa-color-window-item-over',
    store: {model: 'SA.model.color.Color'},

    listeners: {
        afterrender(view) {
            var win = view.up('[window]');

            view.on('itemclick', function(sm, record) {
                win.setColor(record);
            });
        }
    },

    tpl: [
        '<span class="sa-color-window-recent-aligner"></span>',
        '<span class="sa-color-window-recent-label">Recent</span>',
        '<tpl for=".">',
            '<span class="sa-color-window-item">',
                '<span class="sa-color-window-item-inner" style="background: #{color}"></span>',
            '</span>',
        '</tpl>'
    ],

    addColor(color) {
        var store = this.store;

        store.removeBy(c => c.getColor() === color.getColor());

        store.insert(0, color);

        if (store.getCount() > 9) {
            store.removeAt(9);
        }
    },

    afterRender() {
        this.callParent();

        this.on('itemclick', (sm, record) => {
            this.fireEvent('select:color', this, record);
        });
    }
});